import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-upload-hat-sat',
  standalone: false,
  templateUrl: './upload-hat-sat.component.html',
  styleUrl: './upload-hat-sat.component.scss'
})
export class UploadHatSatComponent implements OnInit, OnDestroy, AfterViewInit {
  commentForm: FormGroup;
  @Input() id: any; @Input() step: any; @Input() stepDetails: any;
  @Input() isEditable: boolean = false; @Input() proposalName: any; @Input() proposalId: any;
  @Input() url: string; @Input() postUrl: string;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() generatePDFEmitter = new EventEmitter<any>();
  isEditorDisabled = false;
  init: EditorComponent['init'] = init;
  private subscriptions = new Subscription();
  userID: any; data: any;
  editorReady = false;

  constructor(private fb: FormBuilder, private messageService: MessageService, private api: ApiService) {
    this.userID = sessionStorage.getItem('user_role_id');
  }

  ngOnInit(): void {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
      hat_date: ['', Validators.required],
      sat_date: ['', Validators.required],
      platform: [''],
      location: ['']
      
    });
    this.getDetails();
  }

  ngOnDestroy() { this.subscriptions.unsubscribe(); }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }

  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit();
      this.editorReady = true;
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] { return { readonly: this.isEditorDisabled }; }

  getDetails() {
    if (!this.id) return;
    const sub = this.api.getAPI(`${this.url}?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`).subscribe({
      next: (res: any) => {
        this.data = res[0];
        if (this.data) this.commentForm.patchValue({
          comment: this.data.comment || '', hat_date: this.data.hat_date || '', sat_date: this.data.sat_date || '', platform: this.data.platform || '', location: this.data.location || ''
        });
      },
      error: (err) => { console.error('Error loading data:', err); }
    });
    this.subscriptions.add(sub);
  }

  onSubmit(): void {
    // if (this.commentForm.invalid) { this.commentForm.markAllAsTouched(); return; }
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('comment', this.commentForm.get('comment').value);
    formData.append('hat_date', this.commentForm.get('hat_date').value);
    formData.append('sat_date', this.commentForm.get('sat_date').value);
    formData.append('platform', this.commentForm.get('platform').value);
    formData.append('location', this.commentForm.get('location').value);
    if (this.data?.id) {
      const sub = this.api.putAPI(`${this.url}${this.data.id}/`, formData).subscribe({
        next: (res: any) => {
          this.getDetails();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.detail || 'Failed to update data' });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(this.url, formData).subscribe({
        next: (res: any) => {
          this.getDetails();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data saved successfully' });
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.detail || 'Failed to save data' });
        }
      });
      this.subscriptions.add(sub);
    }
  }

  goToNextStep() { this.stepCompleted.emit(); }

  generatePDF() {
    const payload = {
      url: `${this.url}version-control/`,
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "Comment", value: this.commentForm.get('comment')?.value },
        { key: "HATs Date", value: this.commentForm.get('hat_date')?.value },
        { key: "SATs Date", value: this.commentForm.get('sat_date')?.value },
        { key: "Platform", value: this.commentForm.get('platform')?.value },
        { key: "Location", value: this.commentForm.get('location')?.value }
      ]
    };
    this.generatePDFEmitter.emit(payload);
  }
}
